import { createEntityAdapter } from '@reduxjs/toolkit';
import { type Step } from '@wix/ambassador-groups-onboarding-v1-onboarding/types';

export const stepsAdapter = createEntityAdapter<Step>({
  selectId: (step) => step.stepKey as string,
});

export const selectors = stepsAdapter.getSelectors();
